import { render, staticRenderFns } from "./pacientHeader.vue?vue&type=template&id=2b4d5c5e"
import script from "./pacientHeader.vue?vue&type=script&lang=js"
export * from "./pacientHeader.vue?vue&type=script&lang=js"
import style0 from "./pacientHeader.vue?vue&type=style&index=0&id=2b4d5c5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports